import { render, staticRenderFns } from "./Reactions.vue?vue&type=template&id=6dc0a182&scoped=true&"
import script from "./Reactions.vue?vue&type=script&lang=js&"
export * from "./Reactions.vue?vue&type=script&lang=js&"
import style0 from "./Reactions.vue?vue&type=style&index=0&id=6dc0a182&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6dc0a182",
  null
  
)

export default component.exports